import { Stack } from "@mui/material";

import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { IncomeListSection } from "./components/income-list-section/IncomeListSection";
import { IncomeProofsSection } from "./components/income-proofs-section/IncomeProofsSection";
import { SeizableAmountSection } from "./components/seizable-amount-section/SeizableAmountSection";
import { SelfEmploymentSection } from "./components/self-employment-section/SelfEmploymentSection";
import { useAssetIncome } from "./hooks/useAssetIncome";

export function IncomeView() {
  const { clientId } = useClientFileContext();
  const { formik, assessment, missingFields, onAddMove, onCancelMove } = useAssetIncome(clientId);

  return (
    <ClientContent formik={formik} missingFields={missingFields}>
      <Stack gap={2}>
        <SelfEmploymentSection formik={formik} />
        <SeizableAmountSection assessment={assessment} />
        <IncomeListSection formik={formik} />
        <IncomeProofsSection clientId={clientId} formik={formik} onAddMove={onAddMove} onCancelMove={onCancelMove} />
      </Stack>
    </ClientContent>
  );
}
